<template>
    <Swiper :modules="[Navigation, Pagination, Thumbs]" v-bind="options">
        <slot></slot>
    </Swiper>
</template>

<script setup>
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import { Swiper } from 'swiper/vue';

const props = defineProps({
    options: {
        type: Object,
        default: () => {
            return {};
        },
    },
});
</script>
